import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHeadPrivatePensionSecondCopy: TableHeadItemRecurse[] = [
  { title: '', flex: 1 },
  { title: 'Nº Cobrança', flex: 1 },
  { title: 'Parcela', flex: 1 },
  { title: 'Competência', flex: 1 },
  { title: 'Data emissão', flex: 1 },
  { title: 'Data vencimento', flex: 1 },
  { title: 'Tipo vencimento', flex: 1 },
  { title: 'Situação', flex: 1 },
  { title: 'Valor', flex: 1 },
];
